module.exports = __webpack_public_path__ + "static/media/opioids.67c1b8ef.svg";